<template>
  <main class="main-wrapper flex-grow-1">
      <div class="d-flex align-items-center justify-content-center bg-white w-full">
      <div class="t-headline13 t-color-headlineBlack pda-14 font-m flex-grow-1 fix-header-title d-flex justify-content-center align-items-center">
          {{ $t("724") }}
      </div>
  </div>
  <div class="divider"></div>

  <div class="container container--narrow pdt-50">
      <div class="t-center">
          <img alt="" class="survey-image mgx-auto" src="/images/survey_image.png">
          <div class="t-headline18 font-b t-line-h-33 mgt-8">{{ $t("725") }}</div>
          <div class="mgt-16 t-body6 t-center font-r t-color-bodyGrayA t-line-h-22" v-html="surveyData.closeMessage">

          </div>
      </div>
      <div class="divider mgt-24"></div>
      <div v-if="surveyData.point" class="mgt-24 t-headline11 font-m t-line-16">{{ $t("726") }}</div>
      <div v-if="surveyData.point" class="mdc-card  mgb-24 pdt-24 pdb-16 pdl-24 pdr-24 mgt-16">
          <div class="d-flex justify-content-between align-items-center">
              <div class="t-headline7 font-m  mgb-16">{{ $t("727") }}</div>
              <div class="t-subtitle3 ">{{
                        $t("729", {
                          str: $n(
                            surveyData.point.allResponse +
                              surveyData.point.complete
                          ),
                        })
                      }}</div>
          </div>
          <div class=" pdt-16 pdb-16">
              <div class="d-flex">
                  <div
                      class="t-subtitle2 font-b p-24 bg-iconInactive t-color-white w-24 h-24 d-flex justify-content-center align-items-center b-radius50">
                      P</div>
                  <div class="t-body1 font-r t-color-bodyGrayA pdl-16 l-spacing48 flex-grow-1">
                    {{ $t("730") }}
                  </div>
                  <div class="t-body1 ">{{ $t("701", { str: $n(surveyData.point.complete) }) }}</div>
              </div>
          </div>
          <div class="pdt-16 pdb-16">
              <div class="d-flex">
                  <div
                      class="t-subtitle2 font-b p-24 bg-iconInactive t-color-white w-24 h-24 d-flex justify-content-center align-items-center b-radius50">
                      P</div>
                  <div class="t-body1 font-r t-color-bodyGrayA pdl-16 l-spacing48 flex-grow-1">
                    {{ $t("731") }}
                  </div>
                  <div class="t-body1 ">
                    {{$t("701", { str: $n(surveyData.point.allResponse) })}}
                  </div>
              </div>
          </div>

      </div>

      <div v-if="surveyData.badges && surveyData.badges.length" class="mdc-card  mgb-50 pdt-24 pdb-8 pdl-24 pdr-24">
          <div class="t-headline7 font-m  mgb-16">{{ $t("732") }}</div>
          <div v-for="(badge, index) in surveyData.badges"
              :key="index"
              class="pdt-8 pdb-8 d-flex align-items-center">
              <img v-if="badge.image"  :src="badge.image" alt="" class="icon56">
              <div class="t-body1 font-r t-color-botyGrayA l-spacing48 pdl-20">
                 {{ badge.name }}
              </div>
          </div>
      </div>

      <div class="mgt-50">
          <button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8" @click="moveSurveyFeedback()" @keypress="moveSurveyFeedback()">
              <div class="mdc-button__ripple"></div>
              <span class="mdc-button__label t-body2 font-r">{{ $t("733") }}</span>
          </button>
          <button class="mdc-button  mdc-button--raised bg-secondaryBtn t-color-secondaryBtnText  b-radius4" @click="goBackToSurvey" @keypress="goBackToSurvey">
              <div class="mdc-button__ripple"></div>
              <span class="mdc-button__label t-body2 font-r">{{ $t("734") }}</span>
          </button>
          <div class="mgb-50"></div>
      </div>
  </div>
  </main>
</template>

<script>
/**
 * 설문 결과 컴포넌트(survey result component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import surveyApi from "@/api/surveyApi.js";
import { surveyMixin } from "@/mixins/survey.js";
import {MDCRipple} from '@material/ripple'

export default {
  name: "surveyResult",

  mixins: [surveyMixin],

  data() {
    return {
      surveyData: {},
    };
  },

  created() {
    this.fatchData();
    this.$parent.fatchData();
  },

  mounted() {
    this.setMaterialUi()
  },

  methods: {
    // 설문 결과 데이터(get survey respondent result data)
    setMaterialUi() {
      const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
        let button = new MDCRipple.attachTo(el)
        return button
      })
    },

    fatchData() {
      let params = {
        respondentId: this.$route.params.respondentId,
      };

      surveyApi.surveyRespondentResult(params).then((response) => {
        this.surveyData = response.data.data;
      });
    },
  },
};

</script>
<style scoped>
.top-img {
  width: 190.3px;
  height: 124px;
  display: inline;
}

.t-headline3-result {
  font-size: 1.125rem;
  font-weight: 600;
}
</style>